import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import Head from "@/components/Head/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import UpLoadImg from "@/components/UpLoadImg/index.vue";
import { validStEnpty } from "@/hooks/validate";
import { defineComponent, onMounted, reactive, ref, toRefs } from "vue";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

import { useRoute, useRouter } from "vue-router";
export default defineComponent({
  components: {
    Head: Head,
    UpLoadImg: UpLoadImg
  },
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var route = useRoute();
    var router = useRouter();
    var _route$query = route.query,
        mailboxId = _route$query.mailboxId,
        userId = _route$query.userId;
    var uploadRef = ref(null);
    onMounted(function () {
      //编辑回显
      if (mailboxId && !userId) {
        getDetail();
      }
    }); //初始化下拉

    var options = ref([{
      value: 1,
      label: "建议"
    }, {
      value: 2,
      label: "咨询"
    }, {
      value: 3,
      label: "投诉"
    }]);
    var value = ref(""); //下拉选择

    var typeId = ref(0);

    function selectChange(val) {
      typeId.value = val;
    } //图片


    var files = [];

    function Imgchange(val) {
      files = val;
    } //定义图片
    //表单验证


    var ruleForm = reactive({
      title: "",
      content: ""
    });

    var contentPass = function contentPass(rule, value, callback) {
      if (!validStEnpty(ruleForm.title)) {
        callback(new Error("请输入标题"));
      } else {
        callback();
      }
    };

    var contentPass2 = function contentPass2(rule, value, callback) {
      if (!validStEnpty(ruleForm.content)) {
        callback(new Error("请输入内容"));
      } else {
        callback();
      }
    };

    var rules = {
      title: [{
        required: true,
        validator: contentPass,
        trigger: 'blur'
      }, {
        min: 1,
        max: 100,
        message: '最多输入100个字符',
        trigger: 'blur'
      }],
      content: [{
        required: true,
        validator: contentPass2,
        trigger: 'blur'
      }]
    };
    var ruleForms = ref(null); //编辑数据回显
    // 详情信息

    var getDetail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _uploadRef$value, _files;

        var _yield$globalProperti, data, img;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["emailDetail"](mailboxId);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                ruleForm.title = data.title;
                ruleForm.content = data.sendContent;
                value.value = data.typeId;
                (_uploadRef$value = uploadRef.value) === null || _uploadRef$value === void 0 ? void 0 : _uploadRef$value["editFile"](files);

                if (data.img) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", false);

              case 10:
                img = data.img;

                (_files = files).push.apply(_files, _toConsumableArray(img.split(",")));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getDetail() {
        return _ref.apply(this, arguments);
      };
    }(); //写信


    function submitForm() {
      ruleForms.value && ruleForms.value["validate"]( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var api, obj, _yield$globalProperti2, code, msg;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 11;
                    break;
                  }

                  api = "";

                  if (mailboxId) {
                    api = "editEmail";
                  } else {
                    api = "writeEmail";
                  }

                  obj = {};
                  obj = {
                    title: ruleForm.title,
                    sendContent: ruleForm.content,
                    typeId: value.value,
                    mailboxId: mailboxId,
                    img: files.join(',')
                  };
                  _context2.next = 7;
                  return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[api](_objectSpread({}, obj));

                case 7:
                  _yield$globalProperti2 = _context2.sent;
                  code = _yield$globalProperti2.code;
                  msg = _yield$globalProperti2.msg;

                  if (code == 0) {
                    ElMessage.success("操作成功");
                    setTimeout(function () {
                      router.go(-1);
                    }, 300);
                  } else {
                    ElMessage.error(msg);
                  }

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }

    return _objectSpread(_objectSpread({
      route: route,
      ruleForm: ruleForm,
      rules: rules,
      value: value,
      options: options,
      ruleForms: ruleForms
    }, toRefs(ruleForm)), {}, {
      submitForm: submitForm,
      selectChange: selectChange,
      files: files,
      uploadRef: uploadRef,
      Imgchange: Imgchange,
      contentPass2: contentPass2,
      contentPass: contentPass
    });
  }
});